module.exports = __webpack_public_path__ + "img/map.f5b39f99.png";